module.exports = __webpack_public_path__ + "img/02.a6e02011.png";